module.exports = __webpack_public_path__ + "static/media/zoom-in.7e19d4fa.png";